import { render, staticRenderFns } from "./Personality.vue?vue&type=template&id=a88366b8&scoped=true&"
import script from "./Personality.vue?vue&type=script&lang=js&"
export * from "./Personality.vue?vue&type=script&lang=js&"
import style0 from "./Personality.vue?vue&type=style&index=0&id=a88366b8&prod&lang=css&"
import style1 from "./Personality.vue?vue&type=style&index=1&id=a88366b8&prod&scoped=true&lang=css&"
import style2 from "./Personality.vue?vue&type=style&index=2&id=a88366b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88366b8",
  null
  
)

export default component.exports